<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [erroremessage]="erroremessage"
  [areaName]="areaName"
  [model]="model"
  [isShowModal]="false"
  [columns]="columns"
  [submitButtonDisabled]="submitButtonDisabled()"
  (valueChangeByApiName)="onChange($event)"
  (onRowSelected)="onRowSelected($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="footer d-flex">
    <ssg-button (click)="printTag()" class="action-btn" label="ایجاد تگ" [disabled]="notPrintable()" buttontype="button">
    </ssg-button>
    <ssg-button (click)="createInvVoucher()" class="action-btn" label="صدور سند" [disabled]="notCreatable()" buttontype="button"> </ssg-button>
    <ssg-button (click)="deleteInvVoucher()" class="action-btn" label="حذف سند" [disabled]="notDeleteable()" buttontype="button"> </ssg-button>
    <ssg-button (click)="btnExport()" class="action-btn" label="ذخیره مقدار شمارش شده" buttontype="button"> </ssg-button>
    <ssg-button (click)="fileinput.click()" class="action-btn" label="باز خوانی مقدار شمارش شده" buttontype="button" [disabled]="notCreatable()">
      <i class="fa fa-times"></i>
      <input #fileinput style="display: none" type="file" accept="text/plain" multiple (change)="openFile($event)" />
    </ssg-button>
    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </div>
  <ng-container class="content">
    <editable-grid
      #editablegrid
      [columns]="TakingOfInventoryDetailList"
      [(dataList)]="model.TakingOfInventoryDetailList"
      [isAdd]="false"
      [DefaultValues]="DefaultValues"
      (valueChanges)="onValueChanges($event)"
      [isDelete]="false">
    </editable-grid>
  </ng-container>
</dynamic-form>
